import { readCookie } from "common/utils/cookie";
import initDeliverToTooltipModal from "./deliver-to-tooltip-mobile/deliver-to-tooltip-mobile";

const initDeliverToTooltips = () => {
  // If selectedCity is "true", it means that current user/guest has selected zip code
  const selectedCity = readCookie("is_city_selected");

  if (selectedCity !== "true") {
    initDeliverToTooltipModal();
  }
};

export default initDeliverToTooltips;
